// extracted by mini-css-extract-plugin
export var articleBox = "PostsListing-module--article-box--KlK75";
export var articleList = "PostsListing-module--article-list--jwzfq";
export var meta = "PostsListing-module--meta--UNq7G";
export var right = "PostsListing-module--right--IECb+";